import { Categories } from "@/utils/lomakkeet";
import { isAdded, isRemoved } from "@/css/label";
import { __ } from "i18n-for-browser";

const labelStyles = {
  addition: isAdded,
  removal: isRemoved
};

export function getMaaratVuodetEsivalinnat(
  data: Record<string, unknown>
): Categories {
  return [
    {
      anchor: "esivalinnat",
      categories: [
        {
          anchor: "noudatetaan",
          components: [
            {
              anchor: "A",
              name: "RadioButtonWithLabel",
              properties: {
                isChecked: !data.isOpiskelijaMaaratMaaraykset,
                labelStyles,
                title: __("tuva.noudatetaanMaaratVuodet")
              }
            }
          ],
          layout: { indentation: "none" }
        },
        {
          anchor: "ei-noudateta",
          components: [
            {
              anchor: "A",
              name: "RadioButtonWithLabel",
              properties: {
                isChecked: data.isOpiskelijaMaaratMaaraykset,
                labelStyles,
                title: __("tuva.maaratVuodetMaaritetaanErikseen")
              }
            }
          ],
          layout: { indentation: "none" }
        }
      ],
      layout: { indentation: "none" }
    }
  ];
}
